export default __webpack_public_path__ + "static/media/clock.c62cfd56.svg";